'use strict';
import orgCalendarTemplate from './ngTemplates/org-calendar.html';


export const calendarStates = {
  orgCalendar: 'app.org-calendar',
};

routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(calendarStates.orgCalendar, {
      title: 'organizations.calendar.title',
      url: '/calendar',
      views: {
        'appContent': {
          template: orgCalendarTemplate,
        },
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/calendar/router.js